export default {
  data() {
    return {
      isMobile: false,
      isPhone: false,
      isTablet: false,
      isTabletLandscape: false,
    }
  },
  mounted() {
    if (process.client) {
      try {
        window.addEventListener("resize", this.mobileUpdate);
        this.mobileUpdate()
      } catch (err) {
        // console.log('window not loaded');
      }
    }
  },
  methods: {
    mobileUpdate() {
      if (process.client) {
        if (window.innerWidth <= 900) {
          this.isMobile = true;
        } else {
          this.isMobile = false;
        }
        if (window.innerWidth <= 600) {
          this.isPhone = true;
        } else {
          this.isPhone = false;
        }
        if (window.innerWidth <= 900) {
          this.isTablet = true;
        } else {
          this.isTablet = false;
        }
        if (window.innerWidth <= 1200) {
          this.isTabletLandscape = true;
        } else {
          this.isTabletLandscape = false;
        }
      }
    }
  },
}
